import { Injectable } from "@angular/core";
import { HttpRequest, HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpResponse } from "@angular/common/http";
import { tap } from "rxjs/operators";
import { Observable } from "rxjs";
import { ApiCallsService } from "./api-calls.service";

@Injectable({
  providedIn: 'root'
})

export class TokenInterceptorService implements HttpInterceptor {
  constructor(private admin: ApiCallsService) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const token = localStorage.getItem("adminToken") ? localStorage.getItem("adminToken") : "";
    if (token)
      req = req.clone({ headers: req.headers.set("authorization", atob(token)) });

    if (this.admin.showLoader) this.admin.loader(true);
    else this.admin.showLoader = true;
    return next.handle(req).pipe(
      tap(
        (event: HttpEvent<any>) => {
          if (event instanceof HttpResponse) {
            this.admin.loader(false);
            return
          }
        },
        (err: any) => {
          this.admin.loader(false);
          if (err instanceof HttpErrorResponse) {
            let path = window.location.pathname
            if (err.error.statusCode == 401 || err.error.statusCode == 520)
              this.admin.errorAlert(err.error.message, true, '');
            else this.admin.errorAlert(err.error.message, false, '');
          }
        })
    );
  }
}
